import { useState } from "react"
import { generate } from "library/guid/index.mjs"

export function useId() {
    const [id] = useState(generate)
    return `id_${id}`
}
